<template>
    <div class="VolunteerFamilyRecord" v-if="RecordData.SubProgramTerritory">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-2">
                    <div><img class="photo-border-square" v-bind:src="ProfilePhotoFileID" style="width:100%;border-radius:20px;" /></div>
                </div>
                <div class="col col-md-10">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ RecordData.Name }}</span></h1>
                    <h4><span>{{ RecordData.SubProgramTerritory.Name}} </span></h4>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <FamilySummary v-bind:record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'Family Info'">
                            <Information v-bind:record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'Program'">
                            <Program v-bind:record-data="RecordData" />
                        </div>
                        <div v-if="PaneShown == 'Hosting History'">
                            <HostingHistory :foster-resource-family-id="RecordData.Id" />
                        </div>
                        <div v-show="PaneShown == 'Case File'">
                            <CaseFile chart-type="FosterResourceFamily"
                                      :chart-record-id="RecordData.Id" />
                        </div>
                        <div v-show="PaneShown == 'New Document'">
                            <NewDocument :form-memberships="SubProgramFormMemberships"
                                         :chart-record-id="RecordData.Id" chart-type="FosterResourceFamily" />
                        </div>
                        <div v-show="PaneShown == 'Log'">
                            <CommunicationLog :family-record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'People'">
                            <People v-bind:record-data="RecordData" />
                        </div>
                        <!--<div v-show="PaneShown == 'Log'">
        <ServiceLog v-bind:record-data="RecordData" />
    </div>-->
                        <div v-show="PaneShown == 'Admin'">
                            <Admin v-bind:record-data="RecordData" />
                        </div>
                        <!--<div v-show="PaneShown == 'Reports'">
        <Reports v-bind:child-record-data="ChildRecordData" />
    </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../../../services/event-bus.js';
    import Admin from "./Admin.vue";
    //import Audit from "./Audit.vue";
    import CaseFile from "../../../../Core/RecordComponents/CaseFile.vue";
    import Information from "./Information.vue";
    import NewDocument from "../../../../Core/RecordComponents/NewDocument.vue";
    import CommunicationLog from "./CommunicationLog.vue";
    import People from "./People.vue";
    //import Team from "./Team.vue";
    import Program from "./Program.vue";
    import FamilySummary from "./Summary.vue";
    import HostingHistory from "./HostingHistory.vue";
    //import ServiceLog from "./ServiceLog.vue";
    //import Reports from "./Reports.vue";
    
    export default {
        name: "VolunteerFamilyRecord",
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.ListData.Id || (vm.RecordData.Id && chartID == vm.RecordData.Id)) {
                    vm.UpdateChartData();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        props: [
            "ListData"
        ],
        
        data: function () {
            return {
                RecordData: {},
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    { name: 'Family Info' },
                    { name: 'Program' },
                    { name: 'Hosting History' },
                    { name: 'Case File' },
                    { name: 'New Document' },
                    { name: 'People' },
                    { name: 'Log' },
                    { name: 'Admin' },
                    //{ name: 'Reports' }
                ],
                ProfilePhotoFileID: ""
            };
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/VolunteerFamilies/" + this.ListData.Id, {}, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                //this.$store.commit("Clients.ClientEnrollmentsList.ReplaceSingleRecord", response.data.data);
                this.RecordData = response.data.data;
                this.ProfilePhotoURL()
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("VolunteerFamilies.Profiles.Remove","HostFamilyList",this.RecordData.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ProfilePhotoURL() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/ResourceFamily/GetPhotoID", { chartID: this.RecordData.Id }, this.ProfilePhotoURLSuccess, () => { }, false);
            },
            ProfilePhotoURLSuccess(response) {
                if (response.data.data != null) {
                    this.ProfilePhotoFileID = this.$baseURL + '/API/Core/Files/GetFileContent/profilephoto?FileID=' + response.data.data;
                }
                else {
                    this.ProfilePhotoFileID = "/images/NoPhotoOnFile.jpg"
                }
            },
        },
        components: {
            Admin,
            Information,
            People,
            Program,
            FamilySummary,
            //ServiceLog,
            //Reports,
            CaseFile,
            NewDocument,
            CommunicationLog,
            HostingHistory
        },
        mounted() { 
            this.UpdateChartData();
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.RecordData.SubProgramMemberships[0].SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "FosterResourceFamily");
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    @media only screen and (max-width: 576px) {
        h4{
        font-size: 1em;
        }
        h1{
        font-size: 1.5em;
        }
    }
    li a{
        color:black !important;
    }
    li.active a {
        color: black !important;
    }
</style>